import React from 'react';
import {
  JsonFormsRendererRegistryEntry,
  UISchemaElement,
  RendererProps,
  WithClassname,
} from '@jsonforms/core';
import { VerticalLayoutRenderer } from './VerticalLayoutRenderer';
import { HorizontalLayoutRenderer } from './HorizontalLayoutRenderer';
import { GroupRenderer } from './GroupRenderer';
import { OtherGroupRenderer } from './OtherGroupRenderer';

type LayoutRendererProps = RendererProps & WithClassname & { dark?: boolean };

export const createLayoutRenderers = (dark?: boolean): JsonFormsRendererRegistryEntry[] => {
  return [
    {
      tester: (uischema: UISchemaElement) =>
        uischema.type === 'VerticalLayout' && uischema.options?.otherGroup ? 10 : -1,
      renderer: (props: LayoutRendererProps) => (
        <OtherGroupRenderer
          {...props}
          dark={dark}
        />
      ),
    },
    {
      tester: (uischema: UISchemaElement) => (uischema.type === 'VerticalLayout' ? 2 : -1),
      renderer: (props: LayoutRendererProps) => (
        <VerticalLayoutRenderer
          {...props}
          dark={dark}
        />
      ),
    },
    {
      tester: (uischema: UISchemaElement) => (uischema.type === 'HorizontalLayout' ? 2 : -1),
      renderer: (props: LayoutRendererProps) => (
        <HorizontalLayoutRenderer
          {...props}
          dark={dark}
        />
      ),
    },
    {
      tester: (uischema: UISchemaElement) => (uischema.type === 'Group' ? 2 : -1),
      renderer: (props: LayoutRendererProps) => (
        <GroupRenderer
          {...props}
          dark={dark}
        />
      ),
    },
  ];
};
